if (document.querySelector('#iconWithTextSplide')) {
  new Splide('#iconWithTextSplide', {
    type: 'loop',
    perPage: 4,
    gap: '16px',
    arrows: false,
    pagination: false,
    autoScroll: {
      speed: 1,
    },
  }).mount(window.splide.Extensions);
}
